type TitleHtmlProps = { html?: string; text?: string; lineBreaks?: boolean };

export const TitleHtml = ({ html, text, lineBreaks = false }: TitleHtmlProps) =>
  html ? (
    // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized in data-access/sanitizeHtml.ts (sanitizeTitleHtml)
    <span dangerouslySetInnerHTML={{ __html: lineBreaks ? html : html.replaceAll(/<br\s*\/?>/gi, ' ') }} />
  ) : (
    text
  );
